import { gql } from '@apollo/client';
export const FEE_TYPE_FIELDS = gql `
  fragment FeeTypeFields on FeeType {
    id
    code
    name
    createdAt
    updatedAt
  }
`;
export const FEE_TYPES = gql `
  ${FEE_TYPE_FIELDS}
  query FEE_TYPES {
    feeTypes {
      ...FeeTypeFields
    }
  }
`;
